// Device types
export const IOS_TABLET = "IOS TABLET";
export const TABLET = "TABLET";
export const IOS_PHONE = "IOS PHONE";
export const PHONE = "PHONE";
export const DESKTOP = "DESKTOP";

// Browser types
export const FIREFOX = "Mozilla Firefox";
export const SAMSUNG_INTERNET = "Samsung Internet";
export const OPERA = "Opera";
export const EDGE_LEGACY = "Microsoft Edge (Legacy)";
export const EDGE_CHROMIUM = "Microsoft Edge (Chromium)";
export const CHROMIUM = "Google Chrome or Chromium";
export const SAFARI = "Apple Safari";
